(function(){
  var bar = document.getElementById('stickyBar');
  var closeBtn = document.getElementById('stickyClose');
  var threshold = 600; // show after scrolling past hero/intro
  var dismissed = false;

  function onScroll(){
    if(dismissed) return;
    if(window.scrollY > threshold){
      bar.classList.add('show');
    } else {
      bar.classList.remove('show');
    }
  }

  closeBtn.addEventListener('click', function(){
    dismissed = true;
    bar.classList.remove('show');
  });

  window.addEventListener('scroll', onScroll, {passive:true});
  onScroll();
})();
;
(function(){
  // Desktop only — skip on tablets/mobile
  if(window.innerWidth < 821) return;

  // Skip if no mouse (touch-primary devices)
  if(window.matchMedia && window.matchMedia('(pointer: coarse)').matches) return;

  // Only fire once per session
  try { if(sessionStorage.getItem('sparkExitShown')) return; } catch(e){}

  var modal = document.getElementById('exitModal');
  var overlay = document.getElementById('exitOverlay');
  var closeBtn = document.getElementById('exitClose');
  var declineBtn = document.getElementById('exitDecline');
  var ctaBtn = document.getElementById('exitCta');

  var armed = false;
  var minDwellMs = 6000; // require 6 sec on page before arming
  var minScroll = 300;   // and require some scroll engagement

  setTimeout(function(){
    if(window.scrollY > minScroll) armed = true;
    // also arm later if they scroll after timeout
    window.addEventListener('scroll', function once(){
      if(window.scrollY > minScroll){ armed = true; window.removeEventListener('scroll', once); }
    }, {passive:true});
  }, minDwellMs);

  function show(){
    if(!armed) return;
    try { if(sessionStorage.getItem('sparkExitShown')) return; } catch(e){}
    try { sessionStorage.setItem('sparkExitShown','1'); } catch(e){}
    modal.classList.add('show');
    overlay.classList.add('show');
    modal.setAttribute('aria-hidden','false');
    document.body.style.overflow = 'hidden';
  }

  function hide(){
    modal.classList.remove('show');
    overlay.classList.remove('show');
    modal.setAttribute('aria-hidden','true');
    document.body.style.overflow = '';
  }

  // Trigger: cursor exits viewport from the top edge
  document.addEventListener('mouseleave', function(e){
    if(e.clientY <= 0 && (e.relatedTarget === null || e.relatedTarget === undefined)){
      show();
    }
  });

  closeBtn.addEventListener('click', hide);
  declineBtn.addEventListener('click', hide);
  overlay.addEventListener('click', hide);
  ctaBtn.addEventListener('click', hide);

  // ESC key dismisses
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape') hide();
  });
})();
;
(function(){
  window.dataLayer = window.dataLayer || [];
  window.ttq = window.ttq || [];
  window.ttq.track = window.ttq.track || function(event, params){ window.ttq.push(['track', event, params]); };
  function baseParams(action){
    return {
      page_type: 'spark_advertorial',
      spark_action: action,
      variant: document.body.getAttribute('data-variant') || '',
      lander: document.body.getAttribute('data-lander') || '',
      page_path: window.location.pathname,
      content_id: 'spark',
      content_type: 'product',
      content_name: 'Spark by Amie'
    };
  }
  var viewParams = baseParams('page_view');
  window.dataLayer.push(Object.assign({ event: 'ViewContent' }, viewParams));
  window.ttq.track('ViewContent', viewParams);
})();
;
(function(){
  var preserveKeys = [
    'gclid','gbraid','wbraid',
    'utm_source','utm_medium','utm_campaign','utm_term','utm_content',
    'msclkid','fbclid','ttclid'
  ];

  var current = new URLSearchParams(window.location.search);
  var kept = new URLSearchParams();

  preserveKeys.forEach(function(key){
    var value = current.get(key);
    if(value) kept.set(key, value);
  });

  var lander = document.body.getAttribute('data-lander') || '';
  var variant = document.body.getAttribute('data-variant') || '';

  if(lander) kept.set('lander', lander);
  if(variant) kept.set('variant', variant);

  if(!kept.toString()) return;

  document.querySelectorAll('a.js-preserve-params[href]').forEach(function(anchor){
    try {
      var url = new URL(anchor.getAttribute('href'), window.location.origin);
      kept.forEach(function(value, key){
        if(!url.searchParams.has(key)) url.searchParams.set(key, value);
      });
      anchor.setAttribute('href', url.pathname + url.search + url.hash);
    } catch(e) {}
  });
})();
;
(function(){
  window.dataLayer = window.dataLayer || [];
  window.ttq = window.ttq || [];
  window.ttq.track = window.ttq.track || function(event, params){ window.ttq.push(['track', event, params]); };
  function baseParams(action){
    return {
      page_type: 'spark_advertorial',
      spark_action: action,
      variant: document.body.getAttribute('data-variant') || '',
      page_path: window.location.pathname,
      content_id: 'spark',
      content_type: 'product',
      content_name: 'Spark by Amie'
    };
  }
  function trackSpark(eventName, params){
    window.dataLayer.push(Object.assign({ event: eventName }, params));
    window.ttq.track(eventName, params);
  }
  document.querySelectorAll('a.js-preserve-params').forEach(function(anchor){
    anchor.addEventListener('click', function(){
      var location = anchor.getAttribute('data-cta-location') || '';
      var params = Object.assign(baseParams(location === 'exit' ? 'exit_cta_click' : 'cta_click'), {
        cta_location: location,
        variant: anchor.getAttribute('data-variant') || document.body.getAttribute('data-variant') || '',
        destination: anchor.getAttribute('href') || ''
      });
      trackSpark('ClickButton', params);
    });
  });
  ['stickyClose','exitClose','exitDecline'].forEach(function(id){
    var button = document.getElementById(id);
    if(!button) return;
    button.addEventListener('click', function(){
      trackSpark('ClickButton', baseParams(id === 'stickyClose' ? 'sticky_dismiss' : 'exit_dismiss'));
    });
  });
  var observed = false;
  var modal = document.getElementById('exitModal');
  if(modal && 'MutationObserver' in window){
    new MutationObserver(function(){
      if(observed || !modal.classList.contains('show')) return;
      observed = true;
      trackSpark('ViewContent', baseParams('exit_modal_shown'));
    }).observe(modal, { attributes: true, attributeFilter: ['class'] });
  }
})();
;(function(){document.documentElement.classList.add('amie-static-rendered');})();
